import React, { useState } from "react";

// Redux stuff
import { connect } from "react-redux";

//styles
import styles from "./projectShowcase.module.css";

//Components
import AddNewProject from "../../components/addNewProject/AddNewProject";

//Material Ui Components
import Topbar from "../../components/topbar/Topbar";
import ArrowDropDownIcon from "@material-ui/icons/ArrowDropDown";
import ArrowDropUpIcon from "@material-ui/icons/ArrowDropUp";

const ProjectShowcase = (props) => {
  const [state, setState] = useState({
    showProjectImage: false,
    addNewProject: false,
  });

  const { showProjectImage, addNewProject } = state;

  const { projects } = props.provider.userData;

  const newProjectState = () => {
    setState((prevState) => ({
      ...prevState,
      addNewProject: !addNewProject,
    }));
  };

  return (
    <div className={styles.container}>
      <Topbar
        name={"Project Showcase 🤩"}
        buttonText={"Add"}
        addNewProject={addNewProject}
        newProjectState={newProjectState}
      />

      <div className={styles.mainContainer}>
        {addNewProject && (
          <AddNewProject
            history={props.history}
            location={props.location}
            match={props.match}
            addNewProject={addNewProject}
            newProjectState={newProjectState}
          />
        )}

        {projects.length !== 0 &&
          projects.map((each, index) => {
            return (
              <div key={index} className={styles.projectShowcaseContainer}>
                <div className={styles.left}>
                  <h3 className={styles.projectTitle}>{each.title}</h3>
                  <h4 className={styles.projectNote}>
                    This project will be displayed on your profile
                  </h4>
                  <div className={styles.projectDescriptionContainer}>
                    <h4 className={styles.projectDescriptionTitle}>
                      Project Description
                    </h4>
                    <span className={styles.projectDescription}>
                      {each.description}
                    </span>
                  </div>
                  <h4 className={styles.projectImageTitle}>
                    <button
                      onClick={() => {
                        setState((prevState) => ({
                          ...prevState,
                          showProjectImage: !showProjectImage,
                        }));
                      }}
                    >
                      {showProjectImage ? (
                        <>
                          Hide Images <ArrowDropUpIcon />
                        </>
                      ) : (
                        <>
                          👁‍🗨 Related Images <ArrowDropDownIcon />
                        </>
                      )}
                    </button>
                  </h4>
                  {showProjectImage && (
                    <div className={styles.projectImagesContainer}>
                      <img
                        src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                        alt=""
                      />
                      <img
                        src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                        alt=""
                      />
                      <img
                        src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                        alt=""
                      />
                    </div>
                  )}
                </div>
                <div className={styles.right}>
                  <h4 className={styles.technologiesHeading}>Technologies</h4>
                  <div className={styles.technologiesContainer}>
                    {each.technologies.map((e, index) => {
                      return <span key={index}>{e}</span>;
                    })}
                  </div>
                  <h4 className={styles.technologiesHeading}>Topics</h4>
                  <div className={styles.technologiesContainer}>
                    {each.topics.map((e, index) => {
                      return <span key={index}>{e}</span>;
                    })}
                  </div>
                  <h4 className={styles.technologiesHeading}>Project Links</h4>
                  <div className={styles.technologiesContainer}>
                    {each.projectLinks.map((e, index) => {
                      return <span key={index}>{e}</span>;
                    })}
                  </div>
                </div>
              </div>
            );
          })}
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  provider: state.provider,
});

export default connect(mapStateToProps, {})(ProjectShowcase);

/* <div className={styles.projectShowcaseContainer}>
          <div className={styles.left}>
            <h3 className={styles.projectTitle}>Project Name</h3>
            <h4 className={styles.projectNote}>
              This project will be displayed on your profile
            </h4>
            <div className={styles.projectDescriptionContainer}>
              <h4 className={styles.projectDescriptionTitle}>
                Project Description
              </h4>
              <span className={styles.projectDescription}>
                This will contain some details of the project. It is important
                to describe your project. As it lets people know how experienced
                you are. This will contain some details of the project. It is
                important to describe your project. As it lets people know how
                experienced you are. This will contain some details of the
                project. It is important to describe your project. As it lets
                people know how experienced you are.
              </span>
            </div>
            <h4 className={styles.projectImageTitle}>
              <button
                onClick={() => {
                  setState((prevState) => ({
                    ...prevState,
                    showProjectImage: !showProjectImage,
                  }));
                }}
              >
                {showProjectImage ? (
                  <>
                    Hide Images <ArrowDropUpIcon />
                  </>
                ) : (
                  <>
                    👁‍🗨 Related Images <ArrowDropDownIcon />
                  </>
                )}
              </button>
            </h4>
            {showProjectImage && (
              <div className={styles.projectImagesContainer}>
                <img
                  src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                  alt=""
                />
                <img
                  src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                  alt=""
                />
                <img
                  src="https://blog.hubbado.com/content/images/2020/01/projectmanager.png"
                  alt=""
                />
              </div>
            )}
          </div>
          <div className={styles.right}>
            <h4 className={styles.technologiesHeading}>Technologies</h4>
            <div className={styles.technologiesContainer}>
              <span>Java</span>
              <span>Blockchain</span>
              <span>Python</span>
            </div>
            <h4 className={styles.technologiesHeading}>Topics</h4>
            <div className={styles.technologiesContainer}>
              <span>C++</span>
              <span>E-Commerce</span>
              <span>Lifestyle</span>
              <span>Startup</span>
            </div>
            <h4 className={styles.technologiesHeading}>Project Links</h4>
            <div className={styles.technologiesContainer}>
              <span>https://www.adityagusain.netlify.com</span>
              <span>https://www.adityagusain.notion.so</span>
              <span>https://www.adityagusain.webflow.co</span>
            </div>
          </div>
        </div> */
